module.exports = __webpack_public_path__ + "img/rio-19.fd52cdf7.png";